import { Schedule } from "@mui/icons-material";

// Small helper to generate a human-friendly label for sync task/group codes
export function generateLabel(code) {
  if (!code || typeof code !== 'string') return 'Unknown Task';

  // Doctor-friendly overrides for well-known sync task codes
  const lower = code.toLowerCase();
  if (lower.includes('priority-sync') || lower.includes('priority_sync') || lower.includes('priority')) {
    return 'Fetching Today\'s Schedule';
  }
  if (lower.includes('full-sync') || lower.includes('full_sync') || lower.includes('full')) {
    return 'Fetching All Data';
  }

  // Fallback transformation for other codes
  return code
    .replace(/task_group@/, '')
    .replace(/resource-sync\./, '')
    .replace(/_/g, ' ')
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (l) => l.toUpperCase());
}

export default generateLabel;
